// URL discrète de l'espace admin : aucun lien public ne mène à ces chemins
// et les pages sont marquées noindex (voir lib/seo.js).
export const ADMIN_BASE = "/gestion-fh-9k27";
export const ADMIN_LOGIN = `${ADMIN_BASE}/connexion`;
export const ADMIN_MDP = `${ADMIN_BASE}/mot-de-passe`;
